var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.43384C0 4.02264 3.5888 0.433838 8 0.433838C9.78156 0.433838 11.4678 1.00702 12.8765 2.09144L11.0174 4.50637C10.1464 3.8359 9.10301 3.48146 8 3.48146C5.26926 3.48146 3.04762 5.7031 3.04762 8.43384C3.04762 11.1646 5.26926 13.3862 8 13.3862C10.1994 13.3862 12.0684 11.9452 12.7125 9.95765H8V6.91003H16V8.43384C16 12.845 12.4112 16.4338 8 16.4338C3.5888 16.4338 0 12.845 0 8.43384Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.433838)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutGoogle);
export default __webpack_public_path__ + "static/media/about_google.fd58b628d20d8d1c9e06993e795d035f.svg";
export { ForwardRef as ReactComponent };